const ListEventOwner = () => import('./ListEventOwner.vue')
const DetailEventOwner = () => import('./DetailEventOwner.vue')
const EditEventOwner = () => import('./EditEventOwner.vue')
const NewEventOwner = () => import('./NewEventOwner.vue')
const TheContainer = () => import('@/containers/TheContainer')
const RouterView = { render: h => h('router-view') }

// Event Owner detail routes (under :id/)
const eventOwnerDetailRoutes = [
    {
        path: 'detail',
        name: 'event_owner.detail',
        component: DetailEventOwner,
        meta: {
            label: 'Event Owner Detail',
            breadcrumb: {
                text: 'Overview'
            }
        },
    },
    {
        path: 'edit',
        name: 'event_owner.edit',
        component: EditEventOwner,
        meta: {
            label: 'Edit Event Owner',
            breadcrumb: {
                text: 'Edit'
            }
        },
    },
]

// Main event owner routes
const eventOwnerRoutes = [
    {
        path: 'list',
        name: 'event_owner.list',
        component: ListEventOwner,
        meta: {
            label: 'List Event Owners',
            // No breadcrumb needed - parent provides it
        },
    },
    {
        path: 'new',
        name: 'event_owner.new',
        component: NewEventOwner,
        meta: {
            label: 'Create new Event Owner',
            breadcrumb: {
                text: 'Create New'
            }
        },
    },
    {
        path: ':id',
        component: RouterView,
        meta: {
            breadcrumb: {
                text: (context) => {
                    const eo = context.store.getters['eventOwner/event_owner']
                    // Se l'event owner non è caricato o l'ID non corrisponde
                    if (!eo || eo.id !== parseInt(context.route.params.id)) {
                        // Trigger del caricamento asincrono (non bloccante)
                        context.store.dispatch('eventOwner/fetchEventOwner', context.route.params.id)
                            .catch(err => console.error('Failed to load event owner for breadcrumb:', err))
                        return `Event Owner #${context.route.params.id}`
                    }
                    return eo.company_name || `Event Owner #${context.route.params.id}`
                },
                to: (context) => ({
                    name: 'event_owner.detail',
                    params: { id: context.route.params.id }
                })
            }
        },
        children: eventOwnerDetailRoutes
    },
]

// Main export
export default [
    {
        path: '/event_owner',
        name: 'event_owner',
        component: TheContainer,
        meta: {
            breadcrumb: {
                to: { name: 'event_owner.list' },
                text: 'Event Owners'
            }
        },
        children: eventOwnerRoutes
    }
]
